export default __webpack_public_path__ + "static/media/freedoom2-1024.ebe0a7fd.png";